import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { applyPasswordTests } from 'utils/password'

export const twoFaSchema = (t: TFunction<'translation', undefined>) => {
  const getFieldBase = (label: string) => {
    return yup
      .string()
      .trim()
      .required(t('fieldRequired', { field: label }))
      .label(label)
  }

  return yup.object({
    password: getFieldBase(t('password')).test({
      name: 'password',
      test: (value, ctx) => {
        const { isValid, message } = applyPasswordTests(value, t)
        return isValid
          ? true
          : ctx.createError({
              message: message,
              path: 'password',
            })
      },
    }),
  })
}
